import React from 'react';
import { Link } from 'react-router-dom';
import { WORD_APP_PATH, DOZEN_APP_PATH } from '../config';
import './SiteFooter.css';

const ALL_RULES = [
  { to: `${WORD_APP_PATH}/rules`, label: 'Слово Дня' },
  { to: `${DOZEN_APP_PATH}/rules`, label: 'Дюжина' }
];

function SiteFooter({ className = '', rules = ALL_RULES }) {
  return (
    <div className={`site-footer ${className}`.trim()}>
      <p className="site-footer-line">From Alliance with love</p>
      {rules.length > 0 && (
        <p className="site-footer-line site-footer-rules-line">
          {rules.length > 1 && 'Правила: '}
          {rules.map((rule, i) => (
            <React.Fragment key={rule.to}>
              {i > 0 && ' · '}
              <Link to={rule.to} className="site-footer-rules">
                {rule.label}
              </Link>
            </React.Fragment>
          ))}
        </p>
      )}
    </div>
  );
}

export default SiteFooter;
